<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="card col-12" *ngIf="isUpdate">
    <div class="card-body">
        <h4 class="card-title">{{person.name}} {{person.lastName}}</h4>
        <h6 class="card-subtitle text-muted">{{person.personalAdditionalInfarmation?.department}} {{person.mission}}
        </h6>
    </div>
    <div class="card-body">
        <p *ngIf="person.mail"><i data-feather="mail"></i> {{person.mail}}</p>
        <p *ngIf="person?.phoneNumber"><i data-feather="phone"></i> {{person.phoneNumber}}</p>
        <p *ngIf="person.address" class="cart-text">{{person.address}}</p>
    </div>
</div>

<div class="card col-12" *ngIf="!isUpdate">
    <form [formGroup]="personForm">
        <div class="row">
            <div class="col-2">
                <label for="title">İsim</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="name" formControlName="name" maxlength="30" />
                    </div>
                    <div *ngIf="personForm.get('name').invalid && personForm.get('name').touched" class="text-danger">
                        İsim zorunludur.
                    </div>
                </div>
            </div>
            <div class="col-2">
                <label for="description">Soyisim</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="lastName" formControlName="lastName"
                            maxlength="50" />
                    </div>
                    <div *ngIf="personForm.get('lastName').invalid && personForm.get('lastName').touched"
                        class="text-danger">
                        Soyisim zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-2">
                <label for="department">Departman</label>
                <div class="form-group">
                    <input type="text" class="form-control" id="department" formControlName="department"
                        maxlength="50" />
                </div>
            </div>

            <div class="col-2">
                <label for="description">Görev</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="mission" formControlName="mission" maxlength="50" />
                    </div>
                    <div *ngIf="personForm.get('mission').invalid && personForm.get('mission').touched"
                        class="text-danger">
                        Görev zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-4">
                <label for="description">Email</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="email" class="form-control" id="mail" formControlName="mail" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-2">
                <label for="birthDay">Doğum Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" formControlName="birthDay"
                        [setDate]="birthDate  ?? date"></ng2-flatpickr>
                </div>
            </div>
            <div class="col-2">
                <label for="startDate">İşe Başlama Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="startDate"
                        [setDate]="startDate ?? date"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-2">
                <label for="description">Tel No</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber"
                            mask="(000) 000 00 00" />
                    </div>

                </div>
            </div>
            <div class="col-2">
                <label for="tc">T.C. Kimlik No</label>
                <div class="form-group">
                    <input type="text" class="form-control" id="tc" formControlName="tc" maxlength="11" />
                </div>
            </div>
            <div class="col-1">
                <label for="wage">Maaş</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="wage" formControlName="wage" />
                </div>
            </div>

            <div class="col-1">
                <label for="workingStatus">Çalışma Durumu</label>
                <div class="form-group">
                    <input type="checkbox" id="workingStatus" formControlName="workingStatus" />
                </div>
            </div>

            <div class="col-2" *ngIf="!personForm.value.workingStatus">
                <label for="leaveJob">İşten Ayrılma Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeLeaveJobOptions" name="dateTime" formControlName="leaveJob"
                        [setDate]="leaveDate ?? date"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-xl-2 col-md-4 col-sm-12 col-12">
                <label for="workingDays">Çalışma Gün Sayısı (Haftalık)</label>
                <div class="form-group">
                    <input type="number" id="workingDays" class="form-control" formControlName="workingDays" />
                    <div *ngIf="personForm.get('workingDays')?.invalid && personForm.get('workingDays')?.touched"
                        class="text-danger">
                        <small *ngIf="personForm.get('workingDays')?.errors?.['min']">
                            En az 1 gün girilmelidir.
                        </small>
                        <small *ngIf="personForm.get('workingDays')?.errors?.['max']">
                            En fazla 7 gün girilmelidir.
                        </small>
                    </div>
                </div>

            </div>

            <div class="col-xl-2 col-md-4 col-sm-12 col-12">
                <label for="workingDayHours">Günlük Çalışma Saati</label>
                <div class="form-group">
                    <input type="number" id="workingDayHours" class="form-control" formControlName="workingDayHours" />
                    <div *ngIf="personForm.get('workingDayHours')?.invalid && personForm.get('workingDayHours')?.touched"
                        class="text-danger">
                        <small *ngIf="personForm.get('workingDayHours')?.errors?.['min']">
                            En az 1 saat girilmelidir.
                        </small>
                        <small *ngIf="personForm.get('workingDayHours')?.errors?.['max']">
                            En fazla 24 saat girilmelidir.
                        </small>
                    </div>
                </div>
            </div>

        </div>


        <div class="row">
            <div class="col-6">
                <label for="emergencyContact">Acil Durum Kontağı</label>
                <div class="form-group">
                    <textarea class="form-control" id="emergencyContact" formControlName="emergencyContact"
                        maxlength="50"></textarea>
                </div>
            </div>
            <div class="col-6">
                <label for="description">Adres</label>
                <div class="form-group">
                    <div class="input-group">
                        <textarea class="form-control" id="address" formControlName="address"
                            maxlength="200"></textarea>
                    </div>
                </div>
            </div>

        </div>


    </form>
</div>

<div class="col-12 row d-flex justify-content-between">
    <div class="card text-center col-xl-2 col-md-5 col-sm-6">
        <div class="card-body">
            <div class="avatar bg-info bg-darken-2 p-50 m-0 mb-1">
                <div class="avatar-content">
                    <i data-feather="clock" class="font-medium-5"></i>
                </div>
            </div>
            <h2 class="font-weight-bolder">{{calculate?.last7Days | number:'1.1-2'}}</h2>
            <p class="mb-0 line-ellipsis">Son 7 Günlük Çalışma Saati</p>
        </div>
    </div>

    <div class="card text-center col-xl-2 col-md-5 col-sm-6">
        <div class="card-body">
            <div class="avatar bg-warning bg-darken-2 p-50 m-0 mb-1">
                <div class="avatar-content">
                    <i data-feather="clock" class="font-medium-5"></i>
                </div>
            </div>
            <h2 class="font-weight-bolder">{{calculate?.last1Month | number:'1.1-2'}}</h2>
            <p class="mb-0 line-ellipsis">Son 1 Aylık Çalışma Saati</p>
        </div>
    </div>

    <div class="card text-center col-xl-2 col-md-5 col-sm-6">
        <div class="card-body">
            <div class="avatar bg-primary bg-darken-2 p-50 m-0 mb-1">
                <div class="avatar-content">
                    <i data-feather="clock" class="font-medium-5"></i>
                </div>
            </div>
            <h2 class="font-weight-bolder">{{calculate?.last1Year | number:'1.1-2'}}</h2>
            <p class="mb-0 line-ellipsis">Son 1 Yıllık Çalışma Saati</p>
        </div>
    </div>

    <div class="card text-center col-xl-2 col-md-5 col-sm-6">
        <div class="card-body">
            <div class="avatar bg-danger bg-darken-2 p-50 m-0 mb-1">
                <div class="avatar-content">
                    <i data-feather="clock" class="font-medium-5"></i>
                </div>
            </div>
            <h2 class="font-weight-bolder">{{calculate?.overtimeHours | number:'1.1-2'}}</h2>
            <p class="mb-0 line-ellipsis">Toplam Fazla Mesai Saati</p>
        </div>
    </div>
</div>

<button class="btn btn-warning" rippleEffect (click)="updateChange()">
    <i data-feather="plus" class="d-sm-none d-inline-block"></i><span class="d-none d-sm-inline-block">{{ isUpdate ==
        false ? 'İptal' : 'Güncelle'}}</span>
</button>

<button class="btn btn-success ml-1" rippleEffect (click)="onSumbit()" *ngIf="!isUpdate" [disabled]="!personForm.valid">
    <i data-feather="plus" class="d-sm-none d-inline-block"></i><span class="d-none d-sm-inline-block">Kaydet</span>
</button>

<ul ngbNav #nav="ngbNav" class="nav-tabs mt-2">
    <li ngbNavItem>
        <a ngbNavLink>İzinler</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="card-body table-responsive">
                    <app-worker-leave-list [personId]="personId"></app-worker-leave-list>
                </div>
            </div>
        </ng-template>
    </li>
    <li ngbNavItem>
        <a ngbNavLink>Bordro</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="card-body table-responsive">
                    <app-payroll-list [personId]="personId"></app-payroll-list>
                </div>
            </div>
        </ng-template>
    </li>
    <li ngbNavItem>
        <a ngbNavLink>Puantaj</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="card-body table-responsive">
                    <app-point-list [personId]="personId"></app-point-list>
                </div>
            </div>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>